var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"faq"},[_c('default',{attrs:{"items":_vm.items,"title":'FAQ',"with-accordion":true,"is-accordion-group":true,"wrap-content":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }